export default "__VITE_ASSET__GVL2IEgb__"